import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { Input } from "../../../editor/Input";
import { MathE } from "../../../../../shared/helper/MathExtension";
import { ACTION_TREE_PARAMETER_ESCAPE_CHAR, ACTION_TREE_VARIABLE_ESCAPE_CHAR, isValidActionNumberValue } from "../../../../../shared/helper/actionTreeHelper";
import { ElementGroup, ElementLabel } from './BaseElements';
export const NumberActionDetail = observer(({
  name,
  value,
  valueSetter,
  disabled,
  allowBlankValue,
  validateNumber
}) => {
  const {
    t
  } = useTranslation();

  function setValue(value) {
    if (MathE.containsNumber(value) || value.startsWith("-") || value.startsWith(ACTION_TREE_PARAMETER_ESCAPE_CHAR) || value.startsWith(ACTION_TREE_VARIABLE_ESCAPE_CHAR)) {
      valueSetter(value);
    }
  }

  return /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, name), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    disabled: disabled,
    value: value,
    className: allowBlankValue && value === "" || isValidActionNumberValue(value) && (!validateNumber || validateNumber(+value)) ? "" : "invalid",
    onChange: event => setValue(event.target.value)
  }));
});